import { formatCalls, formatShare } from './nodeChartTheme';

/**
 * Один тултип на все графики по узлам. Раньше каждый компонент верстал свой, и они
 * разошлись по составу строк — в одном была доля, в другом нет.
 */
const NodeChartTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) {
    return null;
  }

  const row = payload[0].payload;
  if (!row) {
    return null;
  }

  return (
    <div
      className="rounded-md border px-3 py-2 text-sm shadow-md max-sm:max-w-[220px] max-sm:text-xs"
      style={{
        background: 'hsl(var(--card))',
        color: 'hsl(var(--card-foreground))',
        borderColor: 'hsl(var(--border))'
      }}
    >
      <div className="mb-1 font-medium">{row.label}</div>
      <div>Звонков: {formatCalls(row.calls)}</div>
      <div className="text-muted-foreground">Доля: {formatShare(row.share)}</div>
    </div>
  );
};

export default NodeChartTooltip;
